const checkPermission = (role, page) => {
    if (role === 'superadmin') return true
    else {
        const permission = localStorage.getItem('permission')
        if (role === 'admin' && permission) {
            const parsePermission = JSON.parse(permission)
            if (parsePermission.includes(page))
                return true
            else return false
        }
        else return false
    }
    // return true
}

export { checkPermission }


// WEBPACK FOOTER //
// ./src/services/permissions.js